import React from 'react'
import './App.scss'
import Footer from './Footer/Footer'
import Header from './Header/Header'
import Main from './Main/Main'

function App() {
	return (
		<>
			<Header />
			<Main />
			<Footer />
		</>
	)
}

export default App
